import { REQ_SEARCHABLE_FIELDS } from "./jobs.constants";

// ── Archive Status ────────────────────────────────────────────────────────────
export const JD_ARCHIVE_STATUS = {
  ARCHIVED: "ARCHIVED",
  ACTIVE: "ACTIVE",
};

// ── Pagination Defaults ───────────────────────────────────────────────────────
export const JD_ARCHIVE_PAGE_SIZE = 10;
export const JD_ARCHIVE_PAGE_SIZE_OPTIONS = ['10', '20', '30', '50'];

// ── Backend Error Codes ───────────────────────────────────────────────────────
export const JD_ARCHIVE_ERROR_CODES = {
  INVALID_PARAM: 7002,
  NOT_FOUND: 7004,
  EMPLOYEE_ASSIGNED: 7005,
};

// ── Messages ──────────────────────────────────────────────────────────────────
export const JD_ARCHIVE_MESSAGES = {
  ARCHIVE_SUCCESS: "Job description archived successfully",
  ARCHIVE_FAILED: "Failed to archive job description",
  ERR_INVALID_PARAM: "Invalid request",
  ERR_NOT_FOUND: "Not found",
  ERR_NOT_FOUND_DESC: "The job description was not found or is already in the requested state.",
  ERR_EMPLOYEE_ASSIGNED: "Cannot archive job description",
  ERR_EMPLOYEE_ASSIGNED_DESC: "An employee is currently assigned to this job description.",
};

// ── Search ────────────────────────────────────────────────────────────────────
// The rows come from the same requisition API the Jobs Library flat view uses,
// so the searchable fields are Jobs Library's, plus `job_title`: the Role Name
// column renders `job_title_for_jd || job_title`, and REQ_SEARCHABLE_FIELDS
// carries only the former — without the fallback, a row showing a role name
// would be unfindable by it.
export const JD_ARCHIVE_SEARCHABLE_FIELDS = [...REQ_SEARCHABLE_FIELDS, 'job_title'];

export const JD_ARCHIVE_SEARCH_PLACEHOLDER = 'Search JD Archive…';
export const JD_ARCHIVE_SEARCH_TOOLTIP =
  'Search across REQ #, job code, role name, business unit, location, function, sub-function, and job level. Case-insensitive.';
